import pattern_config from '#core/pattern-config';
import expandable from '#partial/expandable/expandable';


// Mobile-expandable / desktop-always-visible toggle for the hero footer
// (jump nav, etc.). Generic behavior lives in expandable.responsive() —
// reusable for any region with the same UX requirement.
expandable.responsive({
	id: 'hero',
	selector: '[data-hero-footer] .expandable-button--hero',
	breakpoint: pattern_config.hero.layout_switch,
});
